export const renderCodeDescriptionOption = (option) =>
  option?.description ?? option?.code ?? option?.label ?? '';

export const getCodeOnlyLabel = (option) =>
  option?.description ?? option?.code ?? option?.label ?? '';

export const CODE_DESCRIPTION_SELECT_PROPS = {
  renderOption: renderCodeDescriptionOption,
  getSelectedLabel: getCodeOnlyLabel,
};

export const createCodeDescriptionFilterRenderers = ({
  codeField = 'code',
  descriptionField = 'description',
} = {}) => ({
  renderOption: (option) => option?.[descriptionField] ?? option?.[codeField] ?? '',
  getSelectedLabel: (option) => option?.[descriptionField] ?? option?.[codeField] ?? '',
});

export const CODE_DESCRIPTION_FILTER_PROPS = createCodeDescriptionFilterRenderers();

export const RAW_CODE_DESCRIPTION_FILTER_PROPS = createCodeDescriptionFilterRenderers({
  codeField: 'Code',
  descriptionField: 'Description',
});
